import gql from "graphql-tag"
import PREVIEW_IMAGE_FRAGMENT from "graphql/fragments/PreviewImageFragment"

const GET_REVIEW_CASE_FOLDER = gql`
  query GetReviewCaseFolder($id: ID!) {
    caseFolder(id: $id) {
      id
      documents {
        id
        orders {
          id
          customerFriendlyId
          caseFolder {
            id
          }

          alerting {
            smallText
            text
            type
          }
          mediaOrder {
            isLocked
            media {
              id
              friendlyName
            }
            publishConversation {
              messageFromMedia
              codeLate
              isCodeLate
              isMessageToMedia
              isMediaSystemOrderNumber
              isMediaCustomerSubriberNumber
              publishReadyStatus
            }
            publishChannels {
              inFamiljesidan
              inMinnesrummet
              inAgency
            }
            preview {
              ...PreviewImageFragment
              price(withVAT: true, priceView: WITH_SERVICE_ORDER) {
                currency
                endCustomer {
                  pricePayRounded
                }
              }
            }
            documentFormat {
              id
              sizeColumns
            }
            publishTimes {
              time
            }
            status {
              color
              status
            }
          }
        }
        documentFormat {
          id
          documentType {
            id
            name
          }
        }
        summary {
          price(withVAT: true, withRounding:STANDARD) {
            endCustomer {
              pricePayRounded
            }
          }
        }
      }
    }
  }
  ${PREVIEW_IMAGE_FRAGMENT}
`

export default GET_REVIEW_CASE_FOLDER
